const DepotManagerMenu = [
    {
        key: "routekey-home",
        label: "sidebar.dashboard",
        path: "/app/dashboard",
        vissbleOnSmallScrren: true,
    },
    {
        key: "routekey-goodsin",
        label: "sidebar.goodsin",
        path: "/app/goodsin",
        vissbleOnSmallScrren: true,
    },
    {
        key: "routekey-dispatchorders",
        label: "sidebar.dispatchorders",
        path: "/app/dispatchorders",
        vissbleOnSmallScrren: true,
    },
    {
        key: "routekey-searchgoods",
        label: "sidebar.searchgoods",
        path: "/app/searchgoods",
        vissbleOnSmallScrren: true,
    },
];

export default DepotManagerMenu;
